/** @jsxImportSource @emotion/react */

import { ContainerStyle } from "./style.index";

const Container = ({ children }: { children: React.ReactNode }) => {
  return <div css={ContainerStyle.self}>{children}</div>;
};

export default Container;
